import { ff } from '@atlassian/jira-feature-flagging';

export default {
	get(): boolean {
		return ff('relay-migration-issue-fields-issue-restrictions_yudid');
	},
};
